import {EmptyPolicyNumber, PolicyNumber, ValidPolicyNumber} from 'ApplicationEntry/models/EnteredPolicyNumber';
import {
  isLoaded as isLoadedProducts,
  Plan,
  PlanModel,
  UnassignedPlanModel,
} from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import {Loaded} from 'Core/models/Async';
import {EmptyString, isNonEmptyString, NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import * as I from 'immutable';
import * as RI from '../RiderInformation';
import {ToPartialMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';
import {
  isLoaded,
  SalaryDeductionOccupationClassInfo,
  SalaryDeductionOccupationClassModel,
  UnassignedSalaryDeductionOccupationClassModel,
} from '../SalaryDeductionOccupationClassModel';

export const riderCodes: RI.OrdinaryRiderCode[] = [
  {
    code: 'APD',
    displayName: '',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'APH',
    displayName: '',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'APO',
    displayName: '',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'BER',
    displayName: '',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'EXT',
    displayName: '',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'DF',
    displayName: 'AP6DF',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'AUC',
    displayName: 'AP6AUC',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'ERS',
    displayName: 'AP6ERS',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'ADD',
    displayName: 'AP6ADD',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
];

const riderCodesAPDIR1: RI.OrdinaryRiderCode[] = [
  {
    code: 'APDI',
    displayName: '',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'APH',
    displayName: '',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'APO',
    displayName: '',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'BER',
    displayName: '',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'EXT',
    displayName: '',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'DF',
    displayName: 'AP6DF',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'AUC',
    displayName: 'AP6AUC',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'ERS',
    displayName: 'AP6ERS',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
  {
    code: 'ADD',
    displayName: 'AP6ADD',
    units: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0],
  },
];

type AccidentProps = {
  productType: StringUnion;
  planType: StringUnion;
  premium: StringUnion;
  calculatedPremium: StringUnion;
  monthlySalary: StringUnion;
  cwa: StringUnion;
  section125: boolean;
  selectCgi: boolean;
  selectCgiEnabled: boolean;
  apdir1: boolean;
  apdir1Enabled: boolean;
  replacement: boolean;
  replacementEnabled: boolean;
  policyNumber: PolicyNumber;
  riderInformation: RI.default;
  productList: PlanModel;
  overrideBillForm: boolean;
  baseUnits: StringUnion;
  occClass: SalaryDeductionOccupationClassModel;
  state: StringUnion;
};

export class InvalidOrdinaryAccident {
  public readonly key = 'InvalidOrdinaryAccident';

  constructor(
    public readonly productType: StringUnion,
    public readonly planType: StringUnion,
    public readonly premium: StringUnion,
    public readonly calculatedPremium: StringUnion,
    public readonly monthlySalary: StringUnion,
    public readonly cwa: StringUnion,
    public readonly section125: boolean,
    public readonly selectCgi: boolean,
    public readonly selectCgiEnabled: boolean,
    public readonly apdir1: boolean,
    public readonly apdir1Enabled: boolean,
    public readonly replacement: boolean,
    public readonly replacementEnabled: boolean,
    public readonly policyNumber: PolicyNumber,
    public readonly riderInformation: RI.default,
    public readonly productList: PlanModel,
    public readonly overrideBillForm: boolean,
    public readonly baseUnits: StringUnion,
    public readonly occClass: SalaryDeductionOccupationClassModel,
    public readonly state: StringUnion
  ) {}
}

export class ValidOrdinaryAccident {
  public static createApp({
    productType,
    planType,
    premium,
    calculatedPremium,
    monthlySalary,
    cwa,
    section125,
    selectCgi,
    selectCgiEnabled,
    apdir1,
    apdir1Enabled,
    replacement,
    replacementEnabled,
    policyNumber,
    riderInformation,
    productList,
    overrideBillForm,
    baseUnits,
    occClass,
    state,
  }: AccidentProps) {
    return this.create(
      productType,
      planType,
      premium,
      calculatedPremium,
      monthlySalary,
      cwa,
      section125,
      selectCgi,
      selectCgiEnabled,
      apdir1,
      apdir1Enabled,
      replacement,
      replacementEnabled,
      policyNumber,
      riderInformation,
      productList,
      overrideBillForm,
      baseUnits,
      occClass,
      state
    );
  }

  public static create(
    productType: StringUnion,
    planType: StringUnion,
    premium: StringUnion,
    calculatedPremium: StringUnion,
    monthlySalary: StringUnion,
    cwa: StringUnion,
    section125: boolean,
    selectCgi: boolean,
    selectCgiEnabled: boolean,
    apdir1: boolean,
    apdir1Enabled: boolean,
    replacement: boolean,
    replacementEnabled: boolean,
    policyNumber: PolicyNumber,
    riderInformation: RI.default,
    productList: PlanModel,
    overrideBillForm: boolean,
    baseUnits: StringUnion,
    occClass: SalaryDeductionOccupationClassModel,
    state: StringUnion
  ) {
    return isNonEmptyString(productType) &&
      planType &&
      isNonEmptyString(premium) &&
      isNonEmptyString(monthlySalary) &&
      isNonEmptyString(cwa) &&
      isLoaded(occClass) &&
      section125 &&
      selectCgi &&
      selectCgiEnabled &&
      apdir1 &&
      apdir1Enabled &&
      replacement &&
      replacementEnabled &&
      policyNumber &&
      riderInformation.codes.size > 0 &&
      riderInformation.amounts.size > 0 &&
      isLoadedProducts(productList)
      ? new ValidOrdinaryAccident(
          productType,
          planType,
          premium,
          calculatedPremium,
          monthlySalary,
          cwa,
          section125,
          selectCgi,
          selectCgiEnabled,
          apdir1,
          apdir1Enabled,
          replacement,
          replacementEnabled,
          policyNumber,
          riderInformation,
          productList,
          overrideBillForm,
          baseUnits,
          occClass,
          state
        )
      : new InvalidOrdinaryAccident(
          productType,
          planType,
          premium,
          calculatedPremium,
          monthlySalary,
          cwa,
          section125,
          selectCgi,
          selectCgiEnabled,
          apdir1,
          apdir1Enabled,
          replacement,
          replacementEnabled,
          policyNumber,
          riderInformation,
          productList,
          overrideBillForm,
          baseUnits,
          occClass,
          state
        );
  }

  public readonly key = 'ValidOrdinaryAccident';
  constructor(
    public readonly productType: StringUnion,
    public readonly planType: StringUnion,
    public readonly premium: StringUnion,
    public readonly calculatedPremium: StringUnion,
    public readonly monthlySalary: StringUnion,
    public readonly cwa: StringUnion,
    public readonly section125: boolean,
    public readonly selectCgi: boolean,
    public readonly selectCgiEnabled: boolean,
    public readonly apdir1: boolean,
    public readonly apdir1Enabled: boolean,
    public readonly replacement: boolean,
    public readonly replacementEnabled: boolean,
    public readonly policyNumber: PolicyNumber,
    public readonly riderInformation: RI.default,
    public readonly productList: Loaded<Plan[]>,
    public readonly overrideBillForm: boolean,
    public readonly baseUnits: StringUnion,
    public readonly occClass: Loaded<SalaryDeductionOccupationClassInfo>,
    public readonly state: StringUnion
  ) {}
}

export type OrdinaryAccident = InvalidOrdinaryAccident | ValidOrdinaryAccident;

export type OrdinaryAccidentOptions<TReturn> = ToPartialMatchOptions<OrdinaryAccident, 'key', TReturn>;

export const matchOrdinaryAccident = <TReturn>(options: OrdinaryAccidentOptions<TReturn>) => (
  app: OrdinaryAccident
): TReturn => {
  switch (app.key) {
    case 'InvalidOrdinaryAccident':
      return options.InvalidOrdinaryAccident ? options.InvalidOrdinaryAccident(app) : options.default(app);
    case 'ValidOrdinaryAccident':
      return options.ValidOrdinaryAccident ? options.ValidOrdinaryAccident(app) : options.default(app);
  }
};

export const EmptyOrdinaryAccident = new InvalidOrdinaryAccident(
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  false,
  false,
  true,
  false,
  true,
  false,
  true,
  EmptyPolicyNumber,
  new RI.default(I.List<string>(), I.List<number>(), riderCodes),
  new UnassignedPlanModel(),
  false,
  new EmptyString(),
  new UnassignedSalaryDeductionOccupationClassModel(),
  new EmptyString()
);

export const changeProductType = (productType: string) => (app: OrdinaryAccident) => {
  let selectCgi: boolean = false;
  let selectCgiEnabled: boolean = false;
  let apdir1: boolean = false;
  let apdir1Enabled: boolean = true;
  let replacement: boolean = false;
  let replacementEnabled: boolean = true;
  switch (productType) {
    case 'AP2':
    case 'AP3':
      selectCgi = false;
      selectCgiEnabled = true;
      apdir1 = false;
      apdir1Enabled = true;
      replacement = false;
      replacementEnabled = false;
      break;
    case 'AP6':
      selectCgi = false;
      selectCgiEnabled = true;
      apdir1 = false;
      apdir1Enabled = false;
      replacement = false;
      replacementEnabled = true;
      break;
    case 'AP2C':
    case 'AP3C':
    case 'SAP2':
    case 'SAP3':
      selectCgi = false;
      selectCgiEnabled = true;
      apdir1 = false;
      apdir1Enabled = true;
      replacementEnabled = false;
      break;
    default:
      break;
  }
  return ValidOrdinaryAccident.createApp({
    ...app,
    productType: NonEmptyString.create(productType),
    riderInformation: new RI.default(I.List<string>(), I.List<number>(), riderCodes),
    selectCgi,
    selectCgiEnabled,
    apdir1,
    apdir1Enabled,
    replacement,
    replacementEnabled,
  });
};

export const changePlanType = (planType: string) => (app: OrdinaryAccident) => {
  return ValidOrdinaryAccident.createApp({
    ...app,
    planType: NonEmptyString.create(planType),
    riderInformation: new RI.default(I.List<string>(), I.List<number>(), riderCodes),
    policyNumber: EmptyPolicyNumber,
    cwa: new EmptyString(),
    monthlySalary: new EmptyString(),
    premium: new EmptyString(),
  });
};

export const changePremium = (premium: string) => (app: OrdinaryAccident) =>
  ValidOrdinaryAccident.createApp({...app, premium: NonEmptyString.create(premium)});

export const changeCalculatedPremium = (calculatedPremium: string) => (app: OrdinaryAccident) =>
  ValidOrdinaryAccident.createApp({...app, calculatedPremium: NonEmptyString.create(calculatedPremium)});

export const changeMonthlySalary = (monthlySalary: string) => (app: OrdinaryAccident) =>
  ValidOrdinaryAccident.createApp({...app, monthlySalary: NonEmptyString.create(monthlySalary)});

export const changeCWA = (cwa: string) => (app: OrdinaryAccident) =>
  ValidOrdinaryAccident.createApp({...app, cwa: NonEmptyString.create(cwa)});

export const changeSection125 = (section125: boolean) => (app: OrdinaryAccident) =>
  ValidOrdinaryAccident.createApp({...app, section125});

export const changeSelectCgi = (selectCgi: boolean, productTypeValue: string) => (app: OrdinaryAccident) => {
  return ValidOrdinaryAccident.createApp({
    ...app,
    selectCgi,
    apdir1: false,
    apdir1Enabled: productTypeValue === 'AP6' ? false : selectCgi ? false : true,
  });
};

export const changeApdir1 = (apdir1: boolean) => (app: OrdinaryAccident) => {
  return ValidOrdinaryAccident.createApp({
    ...app,
    apdir1,
    selectCgi: false,
    selectCgiEnabled: !apdir1,
    riderInformation: apdir1
      ? new RI.default(I.List<string>(), I.List<number>(), riderCodes)
      : new RI.default(I.List<string>(), I.List<number>(), riderCodes),
  });
};

export const changeReplacement = (replacement: boolean) => (app: OrdinaryAccident) =>
  ValidOrdinaryAccident.createApp({...app, replacement, policyNumber: ValidPolicyNumber.create(new EmptyString())});

export const changePolicyNumber = (policyNumber: StringUnion) => (app: OrdinaryAccident) =>
  ValidOrdinaryAccident.createApp({...app, policyNumber: ValidPolicyNumber.create(policyNumber)});

export const changeRiderInformation = (riderAmount: number, riderCode: string, index: number) => (
  app: OrdinaryAccident
) => {
  const riderInformation = RI.default.changeRiderInformation(
    riderAmount,
    riderCode,
    index,
    app.riderInformation.amounts,
    app.riderInformation.codes
  );
  if (app.state.value === 'CA' && (app.productType.value === 'AP2' || app.productType.value === 'AP3')) {
    const riderAmountArray = riderInformation.riderAmounts.toArray();
    if (riderAmountArray[0] !== undefined) {
      return ValidOrdinaryAccident.createApp({
        ...app,
        apdir1: true,
        selectCgiEnabled: false,
        riderInformation: new RI.default(
          riderInformation.riderCodes,
          riderInformation.riderAmounts,
          app.apdir1 ? riderCodes : riderCodes
        ),
      });
    } else {
      return ValidOrdinaryAccident.createApp({
        ...app,
        apdir1: false,
        selectCgiEnabled: true,
        riderInformation: new RI.default(
          riderInformation.riderCodes,
          riderInformation.riderAmounts,
          app.apdir1 ? riderCodes : riderCodes
        ),
      });
    }
  } else {
    return ValidOrdinaryAccident.createApp({
      ...app,
      apdir1: app.apdir1,
      riderInformation: new RI.default(
        riderInformation.riderCodes,
        riderInformation.riderAmounts,
        app.apdir1 ? riderCodes : riderCodes
      ),
    });
  }
};

export const changeProductList = (products: PlanModel) => (app: OrdinaryAccident) =>
  ValidOrdinaryAccident.createApp({...app, productList: products});

export const changeOverrideBillForm = (overrideBillForm: boolean) => (app: OrdinaryAccident) =>
  ValidOrdinaryAccident.createApp({...app, overrideBillForm});

export const changeBaseUnits = (baseUnits: string) => (app: OrdinaryAccident) =>
  ValidOrdinaryAccident.createApp({...app, baseUnits: NonEmptyString.create(baseUnits)});

export const changeState = (state: string) => (app: OrdinaryAccident) =>
  ValidOrdinaryAccident.createApp({...app, state: NonEmptyString.create(state)});

export type riderCodeType = {code: string; units: number[]};

export const baseUnits = [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0];

export const typeList = ['AP2', 'AP3', 'AP6', 'AP2C', 'AP3C', 'SAP2', 'SAP3'];

export const getAllRiderCodes = () => riderCodes;
